// .u_amo-member-directory-search
class UAMOMemberDirectorySearch extends Uneet {
  constructor (domElement) {
    super(domElement)
    this.__setDebugLevel(3)
    this.memberDirectoryFilters = null
    this.resultItems = []
    this.currentPage = 0
    this.hasLoadMore = false
    this.isLoading = true
    this.loadedCount = 0
    this.__init()
  }

  __init () {
    const memberDirectoryFilters = this._e.querySelectorAll('div.u_amo-member-directory-filters')[0]
    if (memberDirectoryFilters !== undefined) {
      const searchWrapper = this.__debounce(() => {
        this.newSearch()
      }, 500, this)
      this.memberDirectoryFilters = new UAMOMemberDirectoryFilters(memberDirectoryFilters, searchWrapper, searchWrapper)
      this.memberDirectoryFilters.toggleAdvancedFilters(false)
    }
    const loadMoreBtn = this._e.querySelector('button.load-more')
    loadMoreBtn.onClick((ev) => {
      this.searchMore()
    })
    this.__toggleLoader(true)
    this.__toggleHasLoadMore(false)
    this.newSearch()
  }

  newSearch () {
    this.currentPage = 0
    this.loadedCount = 0
    this.__updateLoadedCount()
    this.clearResultList()
    this.searchMore()
  }

  searchMore () {
    this.currentPage = this.currentPage + 1
    this.__toggleLoader(true)
    const searchString = `${this.endpoint}?&page=${this.currentPage}&${this.memberDirectoryFilters.getFilterURLEncodedString()}`
    this.__log(searchString)
    this.__ajax(
      searchString,
      (successData) => {
        const jsonData = JSON.parse(successData.response)
        this.__log('*** Member Search JSON Response: ***')
        this.__log(jsonData)
        this.__toggleHasLoadMore(!jsonData.is_last_page)
        this.__updateLoadedCount(jsonData.total)
        this.__updateTotalCount(jsonData.actual_count)
        this.__generateItems(jsonData.results)
        this.__toggleLoader(false)
      },
      (errorData) => {
        console.log(errorData)
        this.__toggleLoader(false)
        this._e.addClass('hasError')
      }
    )
  }

  clearResultList () {
    Array.from(this._e.querySelector('div.results-wrapper').children).forEach((element) => {
      element.remove()
    })
  }

  __toggleLoader (force = null) {
    if (force !== null) {
      this.isLoading = force
    } else {
      this.isLoading = !this.isLoading
    }

    this._e.toggleClass('isLoading', this.isLoading)
  }

  __toggleHasLoadMore (force = null) {
    this.hasLoadMore = (force !== null) ? force : !this.hasLoadMore

    this._e.toggleClass('hasLoadMore', this.hasLoadMore)
  }

  __generateItems (jsonData) {
    const resultsWrapper = this._e.querySelector('div.results-wrapper')
    jsonData.forEach((item) => {
      const newDiv = document.createElement('div')
      newDiv.addClass('u_amo-member-directory-result')
      const resultItem = new UAMOMemberDirectoryResult(newDiv, item)
      const newContainer = document.createElement('div')
      newContainer.addClass('result-container')
      newContainer.appendChild(newDiv)
      resultsWrapper.appendChild(newContainer)
    })
  }

  __updateLoadedCount (count = null) {
    if (count === null) {
      this.loadedCount = 0
    } else {
      this.loadedCount += count
    }

    this._e.querySelector('div.totals > span.loaded').innerHTML = this.loadedCount
  }

  __updateTotalCount (count) {
    this._e.querySelector('div.result-list-header > span.count').innerHTML = count
    this._e.querySelector('div.totals > span.total').innerHTML = count
  }
}
